function CaptchaQuestion(props) {
    var question = props.question.replaceAll('0',' ');
  
    var preStyle = {
      fontSize: '5px',
      fontWeight: 'bold',
      color: '#fff',
      padding: '0px',
      margin: '0px',
      lineHeight: '4px',
      display: 'inline-block'
    }
  
    return <pre style={preStyle}>
      {question.slice(0, 21)}<br/>
      {question.slice(21, 42)}<br/>
      {question.slice(42, 63)}<br/>
      {question.slice(63, 84)}<br/>
      {question.slice(84, 105)}
      </pre>
  }

  export default CaptchaQuestion